webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(114);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _app = __webpack_require__(87);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _vueRouter = __webpack_require__(113);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(56);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	var router = new _vueRouter2.default(_routes2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<app/>',
	  components: { app: _app2.default },
	  router: router,
	  created: function created() {
	    document.title = __webpack_require__(2).title.ja;
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, WP;
	
	ENV = __webpack_require__(2);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  back: function() {
	    return history.back();
	  },
	  textDecode: function(text) {
	    return text.replace(/\\n/g, "<br>");
	  },
	  getSimpleBreadObjects: function(pageName) {
	    return [
	      {
	        label: "TOP",
	        to: {
	          name: "top"
	        }
	      }, {
	        label: pageName,
	        to: null
	      }
	    ];
	  },
	  judgeIsEnglish: function(route) {
	    return route.fullPath.match(/en/);
	  },
	  getProjectNo: function(projectName) {
	    switch (projectName) {
	      case "project01":
	        return 1;
	      case "project02":
	        return 2;
	      case "project03":
	        return 3;
	      case "supervision":
	        return 4;
	    }
	  }
	};


/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = {
	  title: {
	    ja: "ヨーロッパにおける19世紀日本関連在外資料調査研究・活用",
	    en: "Insights into Japan-related Overseas Artifacts and Documents from 19th-century Europe, Research and Use:"
	  },
	  subTitle: {
	    ja: "日本文化発信に向けた国際連携のモデル構築",
	    en: "Developing the Foundation for International Collaboration in Transmitting Japanese Culture"
	  },
	  copyrights: {
	    ja: "2017 人間文化研究機構ネットワーク型基幹研究プロジェクト",
	    en: ""
	  },
	  primaryNav: [
	    {
	      label: {
	        ja: "総括班",
	        en: "Supervision"
	      },
	      name: "about",
	      params: {
	        projectName: "supervision"
	      }
	    }, {
	      label: {
	        ja: "プロジェクト01",
	        en: "Project 01"
	      },
	      name: "about",
	      params: {
	        projectName: "project01"
	      }
	    }, {
	      label: {
	        ja: "プロジェクト02",
	        en: "Project 02"
	      },
	      name: "about",
	      params: {
	        projectName: "project02"
	      }
	    }, {
	      label: {
	        ja: "プロジェクト03",
	        en: "Project 03"
	      },
	      name: "about",
	      params: {
	        projectName: "project03"
	      }
	    }, {
	      label: {
	        ja: "活動一覧",
	        en: "ACTIVITIES"
	      },
	      name: "posts",
	      params: {
	        projectName: "all",
	        category: "all",
	        page: 1
	      }
	    }, {
	      label: {
	        ja: "刊行物",
	        en: "PUBLICATIONS"
	      },
	      name: "publications",
	      params: {
	        page: 1
	      }
	    }, {
	      label: {
	        ja: "報道記事",
	        en: "NEWS"
	      },
	      name: "news",
	      params: {
	        page: 1
	      }
	    }
	  ],
	  secondaryNav: [
	    {
	      category: "all",
	      label: {
	        ja: "一覧",
	        en: "ALL"
	      }
	    }, {
	      category: "research",
	      label: {
	        ja: "研究調査",
	        en: "RESEARCH"
	      }
	    }, {
	      category: "academic",
	      label: {
	        ja: "学術成果",
	        en: "ACADEMIC"
	      }
	    }, {
	      category: "education",
	      label: {
	        ja: "活用（展示・教育）",
	        en: "APPLICATION"
	      }
	    }, {
	      category: "other",
	      label: {
	        ja: "その他",
	        en: "OTHER"
	      }
	    }
	  ],
	  serverURI: "http://e-zaigai.jp/wp",
	  APIURI: "/wp-json/wp/v2/",
	  categories: [
	    {
	      slug: "project01",
	      id: 2,
	      label: "Project 01"
	    }, {
	      slug: "project02",
	      id: 3,
	      label: "Project 02"
	    }, {
	      slug: "project03",
	      id: 4,
	      label: "Project 03"
	    }, {
	      slug: "supervision",
	      id: 8,
	      label: "総括"
	    }, {
	      slug: "academic",
	      id: 6,
	      label: {
	        ja: "学術成果",
	        en: "ACADEMIC"
	      }
	    }, {
	      slug: "education",
	      id: 7,
	      label: {
	        ja: "活用（展示・教育）",
	        en: "APPLICATION"
	      }
	    }, {
	      slug: "research",
	      id: 5,
	      label: {
	        ja: "研究調査",
	        en: "RESEARCH"
	      }
	    }, {
	      slug: "other",
	      id: 1,
	      label: {
	        ja: "その他",
	        en: "OTHER"
	      }
	    }
	  ],
	  archives: [
	    {
	      slug: "posts",
	      contentType: "posts"
	    }, {
	      slug: "post",
	      contentType: "posts"
	    }, {
	      slug: "publications",
	      contentType: "publication"
	    }, {
	      slug: "publication",
	      contentType: "publication"
	    }, {
	      slug: "news",
	      contentType: "news"
	    }
	  ],
	  pages: [
	    {
	      slug: "top",
	      sections: [
	        {
	          postType: "pages",
	          id: 279,
	          loading: false,
	          content: null
	        }
	      ],
	      latests: [
	        {
	          postType: "posts",
	          loading: false,
	          content: null
	        }
	      ]
	    }, {
	      slug: "project01",
	      title: {
	        ja: "ハインリッヒ・フォン・シーボルト（以下シーボルト〈子〉）収集の「もの資料」及び文献資料の総合調査をもとに、データベース化、展示等の活用事業へと展開させるウィーンを中心としたシーボルト（子）収集日本関係資料の調査研究",
	        en: "Siebold (Child) Collection centered on Vienna Survey research on Japanese related materials"
	      },
	      subTitle: {
	        ja: "Project 01 資源基盤型",
	        en: "Project 01 Resource-based type"
	      },
	      sections: [
	        {
	          postType: "pages",
	          id: 257,
	          loading: false,
	          content: null
	        }, {
	          postType: "pages",
	          id: 265,
	          loading: false,
	          content: null
	        }
	      ],
	      latests: [
	        {
	          postType: "posts",
	          slug: "academic",
	          label: {
	            ja: "学術成果",
	            en: "ACADEMIC"
	          },
	          categoryID: 6,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "education",
	          label: {
	            ja: "教育活動",
	            en: "EDUCATION"
	          },
	          categoryID: 7,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "research",
	          label: {
	            ja: "研究調査",
	            en: "RESEARCH"
	          },
	          categoryID: 5,
	          loading: false,
	          content: null
	        }
	      ]
	    }, {
	      slug: "project02",
	      title: {
	        ja: "博物館学芸員や教育普及担当者と共に、現地の実情やニーズに応じた日本展示を各地で実現させるイギリスにおける日本展示活性化事業",
	        en: "Japan Exhibition Revitalization Project in the UK"
	      },
	      subTitle: {
	        ja: "Project 02 対話型",
	        en: "Project 02 Interactive"
	      },
	      sections: [
	        {
	          postType: "pages",
	          id: 259,
	          loading: false,
	          content: null
	        }, {
	          postType: "pages",
	          id: 267,
	          loading: false,
	          content: null
	        }
	      ],
	      latests: [
	        {
	          postType: "posts",
	          slug: "research",
	          label: {
	            ja: "研究調査",
	            en: "RESEARCH"
	          },
	          categoryID: 5,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "academic",
	          label: {
	            ja: "学術成果",
	            en: "ACADEMIC"
	          },
	          categoryID: 6,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "education",
	          label: {
	            ja: "活用（展示・教育）",
	            en: "APPLICATION"
	          },
	          categoryID: 7,
	          loading: false,
	          content: null
	        }
	      ]
	    }, {
	      slug: "project03",
	      title: {
	        ja: "現地大学及び博物館との連携による資料調査と展示協力を通じて、国内外の日本研究者の養成を支援するスイスにおける大学教育連携事業",
	        en: "College Education Collaboration Project in Switzerland"
	      },
	      subTitle: {
	        ja: "Project 03 人材育成型",
	        en: "Project 03 Human Resource Development Type"
	      },
	      sections: [
	        {
	          postType: "pages",
	          id: 261,
	          loading: false,
	          content: null
	        }, {
	          postType: "pages",
	          id: 269,
	          loading: false,
	          content: null
	        }
	      ],
	      latests: [
	        {
	          postType: "posts",
	          slug: "research",
	          label: {
	            ja: "研究調査",
	            en: "RESEARCH"
	          },
	          categoryID: 5,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "academic",
	          label: {
	            ja: "学術成果",
	            en: "ACADEMIC"
	          },
	          categoryID: 6,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "education",
	          label: {
	            ja: "活用（展示・教育）",
	            en: "APPLICATION"
	          },
	          categoryID: 7,
	          loading: false,
	          content: null
	        }
	      ]
	    }, {
	      slug: "supervision",
	      title: {
	        ja: "プロジェクト間連携による研究成果活用",
	        en: "supervision"
	      },
	      subTitle: {
	        ja: "総括班",
	        en: "Supervision"
	      },
	      sections: [
	        {
	          postType: "pages",
	          id: 263,
	          loading: false,
	          content: null
	        }, {
	          postType: "pages",
	          id: 277,
	          loading: false,
	          content: null
	        }
	      ],
	      latests: [
	        {
	          postType: "posts",
	          slug: "research",
	          label: {
	            ja: "研究調査",
	            en: "RESEARCH"
	          },
	          categoryID: 5,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "academic",
	          label: {
	            ja: "学術成果",
	            en: "ACADEMIC"
	          },
	          categoryID: 6,
	          loading: false,
	          content: null
	        }, {
	          postType: "posts",
	          slug: "education",
	          label: {
	            ja: "活用（展示・教育）",
	            en: "APPLICATION"
	          },
	          categoryID: 7,
	          loading: false,
	          content: null
	        }
	      ]
	    }
	  ],
	  links: [
	    {
	      url: "http://www.nihu.jp",
	      title: {
	        ja: "人間文化研究機構",
	        en: "Lorem ipsum"
	      }
	    }, {
	      url: "http://www.rekihaku.ac.jp/index.html",
	      title: {
	        ja: "国立歴史民俗博物館",
	        en: "Lorem ipsum"
	      }
	    }, {
	      url: "http://www.hi.u-tokyo.ac.jp/index-j.html",
	      title: {
	        ja: "東京大学史料編纂所",
	        en: "Lorem ipsum"
	      }
	    }, {
	      url: "http://www.minpaku.ac.jp",
	      title: {
	        ja: "国立民族学博物館",
	        en: "Lorem ipsum"
	      }
	    }, {
	      url: "http://www.nijl.ac.jp",
	      title: {
	        ja: "国文学研究資料館",
	        en: "Lorem ipsum"
	      }
	    }, {
	      url: "http://www.nichibun.ac.jp/ja/",
	      title: {
	        ja: "国際日本文化研究センター",
	        en: "Lorem ipsum"
	      }
	    }
	  ]
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, request;
	
	ENV = __webpack_require__(2);
	
	request = __webpack_require__(6);
	
	module.exports = {
	  getEndPoint: function(contentType, pageID) {
	    if (pageID == null) {
	      pageID = "";
	    }
	    return ENV.serverURI + ENV.APIURI + contentType + "/" + pageID;
	  },
	  getContent: function(endPoint, container, filter) {
	    if (filter == null) {
	      filter = "";
	    }
	    if (container.loading || container.content !== null) {
	      return;
	    }
	    container.loading = true;
	    return request.get(endPoint).query(filter).end(function(err, res) {
	      var i, j, ref;
	      container.loading = false;
	      container.totalPages = [];
	      for (i = j = 0, ref = res.header["x-wp-totalpages"]; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        container.totalPages.push(i + 1);
	      }
	      return container.content = res.body;
	    });
	  },
	  getProjectID: function(projectSlug) {
	    switch (projectSlug) {
	      case "project01":
	        return 9;
	      case "project02":
	        return 10;
	      case "project03":
	        return 11;
	      case "supervision":
	        return 12;
	    }
	    return "";
	  },
	  getArchivePostType: function(pageSlug) {
	    var archive, j, len, ref;
	    ref = ENV.archives;
	    for (j = 0, len = ref.length; j < len; j++) {
	      archive = ref[j];
	      if (archive.slug === pageSlug) {
	        return archive.contentType;
	      }
	    }
	  },
	  getPageObject: function(pageSlug) {
	    var j, len, page, ref;
	    ref = ENV.pages;
	    for (j = 0, len = ref.length; j < len; j++) {
	      page = ref[j];
	      if (page.slug === pageSlug) {
	        return page;
	      }
	    }
	    return null;
	  },
	  getCategoryID: function(categorySlug) {
	    var category, j, len, ref;
	    ref = ENV.categories;
	    for (j = 0, len = ref.length; j < len; j++) {
	      category = ref[j];
	      if (category.slug === categorySlug) {
	        return category.id;
	      }
	    }
	    return null;
	  },
	  getCategorySlug: function(categoryID) {
	    var category, j, len, ref;
	    ref = ENV.categories;
	    for (j = 0, len = ref.length; j < len; j++) {
	      category = ref[j];
	      if (category.id === categoryID) {
	        return category.slug;
	      }
	    }
	    return null;
	  },
	  hasCategory: function(post, categoryID) {
	    var cat, j, len, ref;
	    ref = post.categories;
	    for (j = 0, len = ref.length; j < len; j++) {
	      cat = ref[j];
	      if (cat === categoryID) {
	        return true;
	      }
	    }
	    return false;
	  },
	  getCategoryFillter: function(categoryID) {
	    return "categories[]=" + categoryID;
	  },
	  getExcludeCategoriesFillter: function(activeCategory, categories) {
	    return this.getExcludeCategoriesQuery(activeCategory, [ENV.categories[0], ENV.categories[1], ENV.categories[2], ENV.categories[3]]);
	  },
	  date: function(post, isEnglish) {
	    if (isEnglish == null) {
	      isEnglish = false;
	    }
	    if ((post.acf.displayDate != null) && post.acf.displayDate !== "") {
	      if (isEnglish) {
	        return post.acf.displayDateEn;
	      } else {
	        post.acf.displayDate;
	      }
	    }
	    return post.date.split("T")[0].replace(/-/g, ".");
	  },
	  isNew: function(post) {
	    var date, dateDiff, timeDiff, today;
	    date = new Date(post.date);
	    today = new Date();
	    timeDiff = today.getTime() - date.getTime();
	    dateDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
	    return dateDiff <= 3;
	  },
	  excerpt: function(post) {
	    if (post.acf.excerpt != null) {
	      return post.acf.excerpt.replace("<br>", "");
	    }
	    return "";
	  },
	  getExcludeCategoriesQuery: function(activeCategoryID, categories) {
	    var category, excludes, id, index, j, k, len, len1, query;
	    excludes = [];
	    for (j = 0, len = categories.length; j < len; j++) {
	      category = categories[j];
	      if (category.id === activeCategoryID) {
	        continue;
	      }
	      excludes.push(category.id);
	    }
	    query = "";
	    for (index = k = 0, len1 = excludes.length; k < len1; index = ++k) {
	      id = excludes[index];
	      query += "categories_exclude[]=" + id;
	      if (index < excludes.length - 1) {
	        query += "&";
	      }
	    }
	    return query;
	  }
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(71)
	
	/* template */
	var __vue_template__ = __webpack_require__(101)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(70)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(100)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46c272df"
	
	module.exports = __vue_exports__


/***/ },
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(63)
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(93)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-202add15"
	
	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(66)
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(96)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2e965b7a"
	
	module.exports = __vue_exports__


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(72)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(102)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4bcd8e1d"
	
	module.exports = __vue_exports__


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(59)
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(89)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(67)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(97)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-311022a9"
	
	module.exports = __vue_exports__


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(79)
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(64)
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(94)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(68)
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(98)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-430235d4"
	
	module.exports = __vue_exports__


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(80)
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e5e752ce"
	
	module.exports = __vue_exports__


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(65)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(95)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-24005ee7"
	
	module.exports = __vue_exports__


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(74)
	
	/* script */
	__vue_exports__ = __webpack_require__(44)
	
	/* template */
	var __vue_template__ = __webpack_require__(104)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-62125bcc"
	
	module.exports = __vue_exports__


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(62)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(92)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1fad93e8"
	
	module.exports = __vue_exports__


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(58)
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(88)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-01fa9603"
	
	module.exports = __vue_exports__


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(82)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f6a99406"
	
	module.exports = __vue_exports__


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(73)
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(103)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(75)
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-65df9b1f"
	
	module.exports = __vue_exports__


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(78)
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a1db8552"
	
	module.exports = __vue_exports__


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(81)
	
	/* script */
	__vue_exports__ = __webpack_require__(54)
	
	/* template */
	var __vue_template__ = __webpack_require__(111)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ee073486"
	
	module.exports = __vue_exports__


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(61)
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(91)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1521c0ae"
	
	module.exports = __vue_exports__


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(77)
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78cc7223"
	
	module.exports = __vue_exports__


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(60)
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(90)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-114dbd43"
	
	module.exports = __vue_exports__


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(69)
	
	/* script */
	__vue_exports__ = __webpack_require__(53)
	
	/* template */
	var __vue_template__ = __webpack_require__(99)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4516cd23"
	
	module.exports = __vue_exports__


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./404/404": 8,
		"./404/404.vue": 8,
		"./archive/archive": 26,
		"./archive/archive.vue": 26,
		"./archive/archiveTemplate": 9,
		"./archive/archiveTemplate.vue": 9,
		"./archive/news/postLink": 10,
		"./archive/news/postLink.vue": 10,
		"./archive/pagenation": 11,
		"./archive/pagenation.vue": 11,
		"./archive/posts/postLink": 5,
		"./archive/posts/postLink.vue": 5,
		"./archive/publications/postLink": 12,
		"./archive/publications/postLink.vue": 12,
		"./common/breadcrumb": 13,
		"./common/breadcrumb.vue": 13,
		"./common/htmlRenderer": 14,
		"./common/htmlRenderer.vue": 14,
		"./common/identity": 15,
		"./common/identity.vue": 15,
		"./common/primaryNav": 16,
		"./common/primaryNav.vue": 16,
		"./common/secondaryNav": 17,
		"./common/secondaryNav.vue": 17,
		"./common/siteFooter": 18,
		"./common/siteFooter.vue": 18,
		"./common/siteHeader": 19,
		"./common/siteHeader.vue": 19,
		"./common/spinner": 4,
		"./common/spinner.vue": 4,
		"./page/about/header": 20,
		"./page/about/header.vue": 20,
		"./page/about/latest": 21,
		"./page/about/latest.vue": 21,
		"./page/about/members": 22,
		"./page/about/members.vue": 22,
		"./page/about/pageTemplate": 23,
		"./page/about/pageTemplate.vue": 23,
		"./page/page": 28,
		"./page/page.vue": 28,
		"./page/top/pageTemplate": 24,
		"./page/top/pageTemplate.vue": 24,
		"./single/single": 29,
		"./single/single.vue": 29,
		"./single/singleTemplate": 25,
		"./single/singleTemplate.vue": 25
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 30;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  components: {
	    siteHeader: __webpack_require__(19),
	    siteFooter: __webpack_require__(18)
	  }
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS;
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  components: {
	    breadcrumb: __webpack_require__(13)
	  },
	  computed: {
	    pageName: function() {
	      return this.$route.name;
	    },
	    breadObjects: function() {
	      return FUNCTIONS.getSimpleBreadObjects(this.pageName);
	    }
	  }
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS, WP;
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  components: {
	    archiveTemplate: __webpack_require__(9)
	  },
	  data: function() {
	    return {
	      prevPageName: null,
	      prevPage: null,
	      prevCategory: null,
	      archive: {
	        loading: false,
	        content: null,
	        totalPages: []
	      }
	    };
	  },
	  computed: {
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    pageNo: function() {
	      if (this.$route.params.page != null) {
	        return this.$route.params.page;
	      } else {
	        return 1;
	      }
	    },
	    category: function() {
	      if (this.$route.params.category != null) {
	        return this.$route.params.category;
	      } else {
	        return "";
	      }
	    },
	    isLoading: function() {
	      return this.archive.loading;
	    },
	    postType: function() {
	      return WP.getArchivePostType(this.pageName.replace("en_", ""));
	    },
	    endPoint: function() {
	      return WP.getEndPoint(this.postType);
	    }
	  },
	  methods: {
	    getPosts: function() {
	      var categoryID, fillter;
	      if (this.isLoading) {
	        return;
	      }
	      if (this.archive.content !== null) {
	        return;
	      }
	      if (this.pageName.replace("en_", "") === "posts") {
	        fillter = "projects=" + WP.getProjectID(this.projectName);
	        if (this.projectName === "all") {
	          fillter = "";
	        }
	        console.log(fillter);
	        categoryID = WP.getCategoryID(this.$route.params.category);
	        if (categoryID !== null) {
	          fillter += "&" + WP.getCategoryFillter(categoryID);
	        }
	      }
	      fillter += "&page=" + this.pageNo;
	      return WP.getContent(this.endPoint, this.archive, fillter);
	    }
	  },
	  mounted: function() {
	    this.prevPageName = this.pageName;
	    this.prevPage = this.pageNo;
	    this.prevCategory = this.category;
	    this.archive = {
	      loading: false,
	      content: null,
	      totalPages: []
	    };
	    return this.getPosts();
	  },
	  updated: function() {
	    if (this.prevPage !== this.pageNo || this.prevPageName !== this.pageName || this.prevCategory !== this.category) {
	      this.prevPageName = this.pageName;
	      this.prevPage = this.pageNo;
	      this.prevCategory = this.category;
	      this.archive = {
	        loading: false,
	        content: null,
	        totalPages: []
	      };
	      return this.getPosts();
	    }
	  }
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS, WP;
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["posts", "totalPages"],
	  components: {
	    pageTemplateProjectHeader: __webpack_require__(27),
	    secondaryNav: __webpack_require__(17),
	    postLink: __webpack_require__(5),
	    publicationLink: __webpack_require__(12),
	    newsLink: __webpack_require__(10),
	    pagenation: __webpack_require__(11),
	    spinner: __webpack_require__(4)
	  },
	  computed: {
	    pageName: function() {
	      return this.$route.name.replace("en_", "");
	    },
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    toAbout: function() {
	      var name;
	      name = !this.isEnglish ? "about" : "en_about";
	      return {
	        name: name,
	        params: {
	          projectName: this.projectName
	        }
	      };
	    }
	  },
	  methods: {
	    renderText: function(strJa, strEn) {
	      if (!this.isEnglish) {
	        return strJa;
	      } else {
	        return strEn;
	      }
	    }
	  }
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS, WP, request;
	
	request = __webpack_require__(6);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["post", "projectName"],
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    date: function() {
	      return WP.date(this.post);
	    },
	    excerpt: function() {
	      return WP.excerpt(this.post);
	    },
	    isNew: function() {
	      return WP.isNew(this.post);
	    },
	    displayTitle: function() {
	      if (!this.isEnglish) {
	        return this.post.title.rendered;
	      } else {
	        if ((this.post.acf.title_en != null) && this.post.acf.title_en) {
	          return this.post.acf.title_en;
	        } else {
	          return this.post.title.rendered;
	        }
	      }
	    },
	    decodedTitle: function() {
	      return this.displayTitle.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
	    }
	  },
	  methods: {
	    renderText: function(strJa, strEn) {
	      if (!this.isEnglish) {
	        return strJa;
	      } else {
	        return strEn;
	      }
	    },
	    url: function(post) {
	      if ((post.acf.url != null) && post.acf.url !== "") {
	        return "http://" + post.acf.url;
	      }
	      if ((post.acf.file != null) && post.acf.file !== false) {
	        return post.acf.file.url;
	      }
	      return "";
	    }
	  }
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = {
	  props: ["totalPages"],
	  computed: {
	    pageName: function() {
	      return this.$route.name;
	    },
	    pageNo: function() {
	      return this.$route.params.page;
	    },
	    category: function() {
	      return this.$route.params.category;
	    }
	  },
	  methods: {
	    renderText: function(strJa, strEn) {
	      if (!this.isEnglish) {
	        return strJa;
	      } else {
	        return strEn;
	      }
	    },
	    pageJump: function(page) {
	      var newParams;
	      if (page === this.pageNo) {
	        return;
	      }
	      newParams = this.$route.params;
	      newParams.page = page;
	      return this.$router.replace({
	        name: this.pageName,
	        params: newParams
	      });
	    }
	  }
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS, WP;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["post", "isNew"],
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      var ref, ref1;
	      if (this.$route.params.projectName != null) {
	        return this.$route.params.projectName;
	      }
	      if (((ref = this.post.projects) != null ? ref.length : void 0) > 1) {
	        return "all";
	      }
	      if (((ref1 = this.post.projects) != null ? ref1.length : void 0) > 0) {
	        switch (this.post.projects[0]) {
	          case 9:
	            return "project01";
	          case 10:
	            return "project02";
	          case 11:
	            return "project03";
	          case 12:
	            return "supervision";
	        }
	      }
	      return "all";
	    },
	    category: function() {
	      if (this.$route.params.category != null) {
	        return this.$route.params.category;
	      } else {
	        return "";
	      }
	    },
	    date: function() {
	      return WP.date(this.post);
	    },
	    excerpt: function() {
	      return WP.excerpt(this.post);
	    },
	    styledTitleJa: function() {
	      if (this.post.acf.titleHTML != null) {
	        return this.post.acf.titleHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, '\'').replace(/&#044;/g, ',').replace(/&amp;/g, '&');
	      }
	    },
	    styledTitleEn: function() {
	      if (this.post.acf.EnTitleHTML != null) {
	        return this.post.acf.EnTitleHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, '\'').replace(/&#044;/g, ',').replace(/&amp;/g, '&');
	      }
	    },
	    titleStyle: function() {
	      if (this.post.acf.titleStyle != null) {
	        try {
	          return JSON.parse(this.post.acf.titleStyle.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, '\'').replace(/&#044;/g, ',').replace(/&amp;/g, '&'));
	        } catch (error) {
	          return null;
	        }
	      }
	      return null;
	    },
	    to: function() {
	      if (this.isEnglish) {
	        return {
	          name: "en_post",
	          params: {
	            id: this.post.id,
	            projectName: this.projectName
	          }
	        };
	      }
	      return {
	        name: "post",
	        params: {
	          id: this.post.id,
	          projectName: this.projectName
	        }
	      };
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    },
	    hasCategory: function(post) {
	      return WP.hasCategory(post, categoryID);
	    },
	    hasSupervision: function(post) {
	      var i, len, project, ref;
	      ref = post.projects;
	      for (i = 0, len = ref.length; i < len; i++) {
	        project = ref[i];
	        if (project === 12) {
	          return true;
	        }
	      }
	      return false;
	    },
	    categoryClasses: function(post) {
	      var category, classes, i, len, ref, ref1;
	      classes = [];
	      if (this.projectName === "all") {
	        if (((ref = post.projects) != null ? ref.length : void 0) > 0) {
	          if (this.hasSupervision(post)) {
	            classes.push("supervision");
	          } else {
	            switch (post.projects[0]) {
	              case 9:
	                classes.push("project01");
	                break;
	              case 10:
	                classes.push("project02");
	                break;
	              case 11:
	                classes.push("project03");
	                break;
	              case 12:
	                return "supervision";
	            }
	          }
	        }
	      } else {
	        classes.push(this.projectName);
	      }
	      ref1 = post.categories;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        category = ref1[i];
	        classes.push(WP.getCategorySlug(category));
	      }
	      return classes;
	    }
	  }
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS, WP, request;
	
	request = __webpack_require__(6);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["post"],
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    date: function() {
	      return WP.date(this.post);
	    },
	    excerpt: function() {
	      return WP.excerpt(this.post);
	    },
	    isNew: function() {
	      return WP.isNew(this.post);
	    },
	    to: function() {
	      if (this.isEnglish) {
	        return {
	          name: "en_publication",
	          params: {
	            id: this.post.id,
	            page: 1
	          }
	        };
	      }
	      return {
	        name: "publication",
	        params: {
	          id: this.post.id,
	          page: 1
	        }
	      };
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    }
	  }
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = {
	  props: ["objects"]
	};


/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = {
	  props: ["content"]
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  data: function() {
	    return {
	      title: ENV.title,
	      subTitle: ENV.subTitle
	    };
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    }
	  }
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  computed: {
	    primaryNav: function() {
	      return ENV.primaryNav;
	    },
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    pageName: function() {
	      return this.$route.name;
	    },
	    toEn: function() {
	      return {
	        name: "en_" + this.$route.name.replace("en_", ""),
	        params: this.$route.params
	      };
	    },
	    toJa: function() {
	      return {
	        name: this.$route.name.replace("en_", ""),
	        params: this.$route.params
	      };
	    }
	  },
	  methods: {
	    renderText: function(text) {
	      if (!this.isEnglish) {
	        return text.ja;
	      } else {
	        return text.en;
	      }
	    },
	    to: function(link) {
	      if (this.isEnglish) {
	        return {
	          name: "en_" + link.name,
	          params: link.params
	        };
	      }
	      return {
	        name: link.name,
	        params: link.params
	      };
	    },
	    isActive: function(link) {
	      if (this.pageName.replace("en_", "") === "about") {
	        return this.$route.params.projectName === link.params.projectName;
	      }
	      if (this.pageName.replace("en_", "") === "posts" || this.pageName.replace("en_", "") === "post") {
	        if (this.$route.params.projectName !== "all") {
	          return this.$route.params.projectName === link.params.projectName;
	        }
	      }
	      if (this.pageName.replace("en_", "") === "publications" || this.pageName.replace("en_", "") === "publication") {
	        return this.pageName.replace("en_", "").replace("s", "") === link.name.replace("s", "");
	      }
	      return this.pageName.replace("en_", "") === link.name;
	    },
	    toClass: function(label) {
	      switch (label) {
	        case "Supervision":
	          return "supervision";
	        case "Project 01":
	          return "project01";
	        case "Project 02":
	          return "project02";
	        case "Project 03":
	          return "project03";
	      }
	      return "";
	    }
	  }
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    secondaryNav: function() {
	      return ENV.secondaryNav;
	    },
	    categoryName: function() {
	      return this.$route.params.category;
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    },
	    to: function(category) {
	      return {
	        name: this.$route.name,
	        params: {
	          projectNo: this.$route.params.projectNo,
	          category: category,
	          page: 1
	        }
	      };
	    },
	    isActive: function(category) {
	      return category === this.categoryName;
	    }
	  }
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  data: function() {
	    return {
	      copyrights: ENV.copyrights,
	      links: ENV.links
	    };
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    }
	  }
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  components: {
	    identity: __webpack_require__(15),
	    primaryNav: __webpack_require__(16)
	  },
	  computed: {
	    isTop: function() {
	      return this.$route.name.replace("en_", "") === "top";
	    }
	  }
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS, WP;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    projectNo: function() {
	      return FUNCTIONS.getProjectNo(this.projectName);
	    },
	    page: function() {
	      return WP.getPageObject(this.projectName.replace("en_", ""));
	    }
	  },
	  methods: {
	    renderText: function(title) {
	      if (!this.isEnglish) {
	        return title.ja;
	      } else {
	        return title.en;
	      }
	    }
	  }
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS, WP;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    projectNo: function() {
	      return FUNCTIONS.getProjectNo(this.projectName);
	    },
	    page: function() {
	      return WP.getPageObject(this.projectName.replace("en_", ""));
	    }
	  },
	  methods: {
	    renderText: function(title) {
	      if (!this.isEnglish) {
	        return title.ja;
	      } else {
	        return title.en;
	      }
	    }
	  }
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS;
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  props: ["container"],
	  components: {
	    postLink: __webpack_require__(5),
	    spinner: __webpack_require__(4)
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    projectNo: function() {
	      return FUNCTIONS.getProjectNo(this.projectName);
	    }
	  },
	  methods: {
	    renderText: function(strJa, strEn) {
	      if (!this.isEnglish) {
	        return strJa;
	      } else {
	        return strEn;
	      }
	    },
	    toPosts: function(categorySlug) {
	      var name;
	      name = this.isEnglish ? "en_posts" : "posts";
	      return {
	        name: name,
	        params: {
	          projectNo: this.projectNo,
	          category: categorySlug,
	          page: 1
	        }
	      };
	    }
	  }
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = {
	  props: ["html"]
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS;
	
	FUNCTIONS = __webpack_require__(1);
	
	module.exports = {
	  props: ["description", "members", "latests"],
	  components: {
	    pageTemplateProjectHeader: __webpack_require__(20),
	    latestPosts: __webpack_require__(21),
	    members: __webpack_require__(22),
	    spinner: __webpack_require__(4)
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    projectNo: function() {
	      return FUNCTIONS.getProjectNo(this.projectName);
	    }
	  },
	  methods: {
	    renderText: function(strJa, strEn) {
	      if (!this.isEnglish) {
	        return strJa;
	      } else {
	        return strEn;
	      }
	    },
	    toPosts: function(categorySlug) {
	      var name;
	      name = this.isEnglish ? "en_posts" : "posts";
	      return {
	        name: name,
	        params: {
	          projectNo: this.projectNo,
	          category: categorySlug,
	          page: 1
	        }
	      };
	    }
	  }
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var FUNCTIONS, WP;
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  components: {
	    aboutPage: __webpack_require__(23),
	    topPage: __webpack_require__(24),
	    spinner: __webpack_require__(4)
	  },
	  data: function() {
	    return {
	      page: null
	    };
	  },
	  computed: {
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      return this.$route.params.projectName;
	    },
	    projectNo: function() {
	      return FUNCTIONS.getProjectNo(this.projectName);
	    },
	    isLoading: function() {
	      var container, i, j, len, len1, ref, ref1, section;
	      ref = this.page.sections;
	      for (i = 0, len = ref.length; i < len; i++) {
	        section = ref[i];
	        if (section.loading) {
	          return true;
	        }
	      }
	      ref1 = this.page.latests;
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        container = ref1[j];
	        if (container.loading) {
	          return true;
	        }
	      }
	      return false;
	    }
	  },
	  methods: {
	    getPageObject: function() {
	      if (this.pageName === "top" || this.pageName === "en_top") {
	        return WP.getPageObject("top");
	      }
	      return WP.getPageObject(this.projectName);
	    },
	    getPosts: function() {
	      var container, endPoint, fillter, i, j, len, len1, ref, ref1, results, section;
	      if (this.isLoading) {
	        return;
	      }
	      ref = this.page.sections;
	      for (i = 0, len = ref.length; i < len; i++) {
	        section = ref[i];
	        if (section.content !== null) {
	          continue;
	        }
	        endPoint = WP.getEndPoint(section.postType, section.id);
	        WP.getContent(endPoint, section);
	      }
	      ref1 = this.page.latests;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        container = ref1[j];
	        if (container.content !== null) {
	          continue;
	        }
	        endPoint = WP.getEndPoint(container.postType);
	        fillter = "";
	        if (this.pageName === "about" || this.pageName === "en_about") {
	          fillter = "projects=" + WP.getProjectID(this.projectName);
	          fillter += "&" + WP.getCategoryFillter(container.categoryID);
	          fillter += "&per_page=1";
	        }
	        results.push(WP.getContent(endPoint, container, fillter));
	      }
	      return results;
	    }
	  },
	  mounted: function() {
	    this.page = this.getPageObject();
	    return this.getPosts();
	  },
	  updated: function() {
	    this.page = this.getPageObject();
	    return this.getPosts();
	  }
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS, WP;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["description", "latests"],
	  components: {
	    postLink: __webpack_require__(5),
	    spinner: __webpack_require__(4)
	  },
	  data: function() {
	    return {
	      pages: [ENV.pages[4], ENV.pages[1], ENV.pages[2], ENV.pages[3]]
	    };
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    toCategory: function() {
	      var name;
	      name = !this.isEnglish ? "posts" : "en_posts";
	      return {
	        name: name,
	        params: {
	          projectName: "all",
	          category: "all",
	          page: 1
	        }
	      };
	    }
	  },
	  methods: {
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    },
	    toAboutPage: function(projectSlug) {
	      return {
	        name: "about",
	        params: {
	          projectName: projectSlug
	        }
	      };
	    },
	    getProjectSlug: function(post) {
	      var category, i, len, ref;
	      ref = ENV.categories;
	      for (i = 0, len = ref.length; i < len; i++) {
	        category = ref[i];
	        if (WP.hasCategory(post, category.id)) {
	          return category.slug;
	        }
	      }
	    }
	  }
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var WP;
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  components: {
	    singleTemplate: __webpack_require__(25),
	    spinner: __webpack_require__(4)
	  },
	  data: function() {
	    return {
	      single: {
	        loading: false,
	        content: null
	      }
	    };
	  },
	  computed: {
	    pageName: function() {
	      return this.$route.name;
	    },
	    id: function() {
	      return this.$route.params.id;
	    },
	    postType: function() {
	      return WP.getArchivePostType(this.pageName.replace("en_", ""));
	    },
	    endPoint: function() {
	      return WP.getEndPoint(this.postType, this.id);
	    }
	  },
	  methods: {
	    getPosts: function() {
	      return WP.getContent(this.endPoint, this.single);
	    }
	  },
	  mounted: function() {
	    return this.getPosts();
	  },
	  updated: function() {
	    return this.getPosts();
	  }
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var ENV, FUNCTIONS, WP;
	
	ENV = __webpack_require__(2);
	
	FUNCTIONS = __webpack_require__(1);
	
	WP = __webpack_require__(3);
	
	module.exports = {
	  props: ["post"],
	  components: {
	    pageTemplateProjectHeader: __webpack_require__(27),
	    htmlRenderer: __webpack_require__(14)
	  },
	  computed: {
	    isEnglish: function() {
	      return FUNCTIONS.judgeIsEnglish(this.$route);
	    },
	    pageName: function() {
	      return this.$route.name;
	    },
	    projectName: function() {
	      if (this.$route.params.projectName != null) {
	        return this.$route.params.projectName;
	      } else {
	        return "";
	      }
	    },
	    styledTitleJa: function() {
	      if (this.post.acf.titleHTML != null) {
	        return this.post.acf.titleHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, '\'').replace(/&#044;/g, ',').replace(/&amp;/g, '&');
	      }
	    },
	    styledTitleEn: function() {
	      if (this.post.acf.EnTitleHTML != null) {
	        return this.post.acf.EnTitleHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, '\'').replace(/&#044;/g, ',').replace(/&amp;/g, '&');
	      }
	    }
	  },
	  methods: {
	    date: function(post) {
	      return WP.date(post);
	    },
	    renderText: function(ja, en) {
	      if (!this.isEnglish) {
	        return ja;
	      } else {
	        return en;
	      }
	    },
	    category: function(post) {
	      var category, i, index, len, ref;
	      ref = ENV.categories;
	      for (index = i = 0, len = ref.length; i < len; index = ++i) {
	        category = ref[index];
	        if (index < 4) {
	          continue;
	        }
	        if (WP.hasCategory(this.post, category.id)) {
	          return category;
	        }
	      }
	      return "";
	    },
	    back: function() {
	      return FUNCTIONS.back();
	    }
	  }
	};


/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = {
	  slug: "",
	  path: "page/page",
	  name: "top",
	  children: [
	    {
	      slug: "about/:projectName",
	      path: "page/page",
	      name: "about"
	    }, {
	      slug: "posts/:projectName/:category/:page",
	      path: "archive/archive",
	      name: "posts"
	    }, {
	      slug: "posts/:projectName/:id",
	      path: "single/single",
	      name: "post"
	    }, {
	      slug: "publications/:page",
	      path: "archive/archive",
	      name: "publications"
	    }, {
	      slug: "publications/:page/:id",
	      path: "single/single",
	      name: "publication"
	    }, {
	      slug: "news/:page",
	      path: "archive/archive",
	      name: "news"
	    }, {
	      slug: "en",
	      path: "page/page",
	      name: "en_top",
	      children: [
	        {
	          slug: "projects/:projectName",
	          path: "page/page",
	          name: "en_about"
	        }, {
	          slug: "archive/:projectName/:category/:page",
	          path: "archive/archive",
	          name: "en_posts"
	        }, {
	          slug: "projects/:projectName/:id",
	          path: "single/single",
	          name: "en_post"
	        }, {
	          slug: "publications/:page",
	          path: "archive/archive",
	          name: "en_publications"
	        }, {
	          slug: "publications/:page/:id",
	          path: "single/single",
	          name: "en_publication"
	        }, {
	          slug: "news/:page",
	          path: "archive/archive",
	          name: "en_news"
	        }
	      ]
	    }
	  ]
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var architecture, i, len, page, ref, routes, setRoute;
	
	architecture = __webpack_require__(55);
	
	setRoute = function(routes, page, parentURL) {
	  var child, i, len, ref, results;
	  parentURL += "/" + page.slug;
	  routes.push({
	    path: parentURL,
	    component: __webpack_require__(30)("./" + page.path),
	    name: page.name
	  });
	  if (page.children != null) {
	    ref = page.children;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      child = ref[i];
	      results.push(setRoute(routes, child, parentURL));
	    }
	    return results;
	  }
	};
	
	routes = [
	  {
	    path: "/",
	    component: __webpack_require__(30)("./" + architecture.path),
	    name: architecture.name
	  }, {
	    path: "/404",
	    component: __webpack_require__(8),
	    name: "404"
	  }
	];
	
	ref = architecture.children;
	for (i = 0, len = ref.length; i < len; i++) {
	  page = ref[i];
	  setRoute(routes, page, "", "components/" + page.path);
	}
	
	routes.push({
	  path: "*",
	  redirect: {
	    name: "404"
	  }
	});
	
	module.exports = {
	  mode: "history",
	  routes: routes
	};


/***/ },
/* 57 */,
/* 58 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 59 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 60 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 61 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 62 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 63 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 64 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 65 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 66 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 69 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 72 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 75 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 76 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 77 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 78 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 79 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 80 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 81 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 82 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(76)
	
	/* script */
	__vue_exports__ = __webpack_require__(31)
	
	/* template */
	var __vue_template__ = __webpack_require__(106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "pageHeaderContainer"
	  }, [_c('p', {
	    staticClass: "projectSubTittle",
	    class: _vm.projectName
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.subTitle)))]), _c('h2', {
	    staticClass: "projectTitle"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.title)))])])
	},staticRenderFns: []}

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('p', {
	    staticClass: "pagenation"
	  }, _vm._l((_vm.totalPages), function(page) {
	    return _c('span', {
	      staticClass: "pagelink",
	      class: {
	        active: page == _vm.pageNo
	      },
	      on: {
	        "click": function($event) {
	          _vm.pageJump(page)
	        }
	      }
	    }, [_vm._v(_vm._s(page))])
	  }))
	},staticRenderFns: []}

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('article', {
	    staticClass: "page"
	  }, [(_vm.page != null) ? _c('div', [(_vm.pageName == 'about' || _vm.pageName == 'en_about') ? _c('aboutPage', {
	    attrs: {
	      "description": _vm.page.sections[0],
	      "members": _vm.page.sections[1],
	      "latests": _vm.page.latests
	    }
	  }) : _vm._e(), (_vm.pageName == 'top' || _vm.pageName == 'en_top') ? _c('topPage', {
	    attrs: {
	      "description": _vm.page.sections[0],
	      "latests": _vm.page.latests
	    }
	  }) : _vm._e()]) : _vm._e(), (_vm.page == null) ? _c('spinner') : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('article', {
	    staticClass: "archive"
	  }, [_c('archiveTemplate', {
	    attrs: {
	      "posts": _vm.archive.content,
	      "totalPages": _vm.archive.totalPages
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "headerContainer",
	    class: {
	      isTop: _vm.isTop
	    }
	  }, [_c('identity'), _c('primaryNav')])
	},staticRenderFns: []}

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('article', {
	    staticClass: "page"
	  }, [_c('header', [_c('breadcrumb', {
	    attrs: {
	      "objects": _vm.breadObjects
	    }
	  }), _c('h1', {
	    staticClass: "pageTitle"
	  }, [_vm._v("404")])]), _c('div', {
	    staticClass: "content"
	  }, [_c('p', {
	    staticClass: "toHome"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'top'
	      }
	    }
	  }, [_vm._v("トップへ戻る")])])])])
	},staticRenderFns: []}

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "htmlRenderer",
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('nav', {
	    staticClass: "secondaryNav",
	    class: _vm.projectName
	  }, [_c('h3', {
	    staticClass: "secondaryNavTitle"
	  }, [_vm._v(_vm._s(_vm.renderText("活動", "ACTIVITY")))]), _c('ul', _vm._l((_vm.secondaryNav), function(link) {
	    return _c('li', {
	      class: {
	        active: _vm.isActive(link.category)
	      }
	    }, [_c('router-link', {
	      class: link.category,
	      attrs: {
	        "to": _vm.to(link.category)
	      }
	    }, [_vm._v(_vm._s(_vm.renderText(link.label.ja, link.label.en)))])])
	  }))])
	},staticRenderFns: []}

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "archiveContainer"
	  }, [_c('header', [(_vm.pageName == 'posts') ? _c('div', [(_vm.projectName != 'all') ? _c('pageTemplateProjectHeader') : _vm._e(), _c('secondaryNav')]) : _vm._e(), (_vm.pageName != 'posts') ? _c('div', [(_vm.pageName == 'publications') ? _c('h2', {
	    staticClass: "pageTitle"
	  }, [_vm._v(_vm._s(_vm.renderText("刊行物", "PUBLICATIONS")))]) : _vm._e(), (_vm.pageName == 'news') ? _c('h2', {
	    staticClass: "pageTitle"
	  }, [_vm._v(_vm._s(_vm.renderText("報道記事", "NEWS")))]) : _vm._e()]) : _vm._e()]), (_vm.posts != null) ? _c('div', [(_vm.posts.length > 0) ? _c('div', [(_vm.pageName == 'posts') ? _c('div', {
	    staticClass: "postLinks"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('postLink', {
	      staticClass: "postLink",
	      attrs: {
	        "post": post
	      }
	    })
	  })) : _vm._e(), (_vm.pageName == 'publications') ? _c('div', {
	    staticClass: "publicationLinks"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('publicationLink', {
	      staticClass: "publicationLink",
	      attrs: {
	        "post": post
	      }
	    })
	  })) : _vm._e(), (_vm.pageName == 'news') ? _c('div', {
	    staticClass: "newsLinks"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('newsLink', {
	      staticClass: "newsLink",
	      attrs: {
	        "post": post
	      }
	    })
	  })) : _vm._e()]) : _vm._e(), (_vm.posts.length == 0) ? _c('p', {
	    staticClass: "notFound"
	  }, [_vm._v("記事はありません")]) : _vm._e()]) : _vm._e(), (_vm.posts == null) ? _c('spinner') : _vm._e(), _c('footer', [_c('pagenation', {
	    attrs: {
	      "totalPages": _vm.totalPages
	    }
	  }), (_vm.pageName == 'posts' && _vm.projectName != 'all') ? _c('p', {
	    staticClass: "back"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.toAbout
	    }
	  }, [_vm._v("← " + _vm._s(_vm.renderText('プロジェクトページへ戻る', 'BACK')))])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('router-link', {
	    staticClass: "postLinkContainer",
	    attrs: {
	      "to": _vm.to
	    }
	  }, [_c('img', {
	    staticClass: "postThumbnail",
	    attrs: {
	      "src": _vm.post.acf.pdfImage.sizes.medium
	    }
	  }), _c('div', {
	    staticClass: "info"
	  }, [_c('p', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn)))]), _c('h2', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))])])])
	},staticRenderFns: []}

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "siteIdentity"
	  }, [_c('img', {
	    staticClass: "backgroundImage",
	    attrs: {
	      "src": "http://e-zaigai.jp/static/images/obi.png"
	    }
	  }), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'top'
	      }
	    }
	  }, [_c('h1', {
	    staticClass: "siteTitle"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.title.ja, _vm.title.en)))]), _c('h2', {
	    staticClass: "siteSubTitle"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.subTitle.ja, _vm.subTitle.en)))])])])
	},staticRenderFns: []}

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('article', {
	    staticClass: "single"
	  }, [(_vm.single.content != null) ? _c('div', [_c('singleTemplate', {
	    attrs: {
	      "post": _vm.single.content
	    }
	  })]) : _vm._e(), (_vm.single.content == null) ? _c('spinner') : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('router-link', {
	    staticClass: "postLinkContainer",
	    class: _vm.category,
	    attrs: {
	      "to": _vm.to
	    }
	  }, [_c('div', {
	    staticClass: "info",
	    class: _vm.categoryClasses(_vm.post)
	  }, [_c('p', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn))), (_vm.isNew) ? _c('span', {
	    staticClass: "new"
	  }, [_vm._v("NEW")]) : _vm._e()]), (!_vm.isEnglish && _vm.styledTitleJa) ? _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.styledTitleJa)
	    }
	  }) : (_vm.isEnglish && _vm.styledTitleEn) ? _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.styledTitleEn)
	    }
	  }) : _c('h2', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))])])])
	},staticRenderFns: []}

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "spinnerContainer"
	  }, [_c('p', {
	    staticClass: "loader"
	  })])
	}]}

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [(_vm.url(_vm.post) != '') ? _c('a', {
	    staticClass: "postLinkContainer",
	    attrs: {
	      "href": _vm.url(_vm.post),
	      "target": "_blank"
	    }
	  }, [_c('p', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date))]), (_vm.post.acf.記載元 == '地方紙') ? _c('p', {
	    staticClass: "category"
	  }, [_vm._v(_vm._s(_vm.renderText("地方紙", "local")))]) : _vm._e(), (_vm.post.acf.記載元 == '全国紙') ? _c('p', {
	    staticClass: "category nation"
	  }, [_vm._v(_vm._s(_vm.renderText("全国紙", "nation")))]) : _vm._e(), _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.decodedTitle)
	    }
	  })]) : _vm._e(), (_vm.url(_vm.post) == '') ? _c('div', {
	    staticClass: "postLinkContainer disabled"
	  }, [_c('p', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date))]), _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.decodedTitle)
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "members",
	    domProps: {
	      "innerHTML": _vm._s(_vm.html)
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "footerContainer"
	  }, [(!_vm.isEnglish) ? _c('div', {
	    staticClass: "links"
	  }, [_c('div', {
	    staticClass: "link-group"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.renderText("関連研究機関", "")))]), _c('ul', _vm._l((_vm.links), function(link) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": link.url,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.renderText(link.title.ja, link.title.en)))])])
	  }))]), _c('div', {
	    staticClass: "link-group"
	  }, [_c('h1', [(!_vm.isEnglish) ? _c('span', [_vm._v("関連研究プロジェクト")]) : _vm._e(), (_vm.isEnglish) ? _c('span', [_vm._v("Lorem ipsum")]) : _vm._e()]), _c('ul', [_c('li', [(!_vm.isEnglish) ? _c('a', {
	    attrs: {
	      "href": "http://www.nihu.jp",
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.renderText("人間文化研究機構「日本関連在外資料調査研究事業」プロジェクト（カテゴリーB）", "")))]) : _vm._e()])])])]) : _vm._e(), (!_vm.isEnglish) ? _c('p', {
	    staticClass: "copy"
	  }, [_vm._v("©" + _vm._s(_vm.copyrights.ja))]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return (_vm.description != null && _vm.members != null) ? _c('div', [_c('header', [_c('pageTemplateProjectHeader')]), (_vm.description.content != null && _vm.members.content != null) ? _c('div', {
	    staticClass: "pageBody"
	  }, [_c('div', {
	    staticClass: "description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.renderText(_vm.description.content.acf.content, _vm.description.content.acf.contentEn))
	    }
	  }), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "columnHeading",
	    class: _vm.projectName
	  }, [_c('h3', {
	    staticClass: "columnTitle"
	  }, [_vm._v(_vm._s(_vm.renderText('研究メンバー', 'MEMBER')))])]), _c('members', {
	    attrs: {
	      "html": _vm.renderText(_vm.members.content.acf.content, _vm.members.content.acf.contentEn)
	    }
	  })]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "columnHeading",
	    class: _vm.projectName
	  }, [_c('h3', {
	    staticClass: "columnTitle"
	  }, [_vm._v(_vm._s(_vm.renderText('活動', 'ACTIVITY')))]), _c('router-link', {
	    staticClass: "toPosts",
	    attrs: {
	      "to": _vm.toPosts('all')
	    }
	  }, [(_vm.projectNo < 4) ? _c('span', [_vm._v("0" + _vm._s(_vm.projectNo) + " ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.renderText('活動 一覧へ', 'MORE')))])])]), _vm._l((_vm.latests), function(container) {
	    return (container.content != null && container.content.length > 0) ? _c('latestPosts', {
	      staticClass: "latest",
	      attrs: {
	        "container": container
	      }
	    }) : _vm._e()
	  })], true)])]) : _vm._e(), (_vm.description.content == null || _vm.members.content == null) ? _c('spinner') : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "site"
	  }, [_c('header', {
	    staticClass: "siteHeader"
	  }, [_c('siteHeader')]), _c('main', {
	    staticClass: "siteBody"
	  }, [_c('router-view')]), _c('footer', {
	    staticClass: "siteFooter"
	  }, [_c('siteFooter')])])
	},staticRenderFns: []}

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "pageHeaderContainer"
	  }, [_c('p', {
	    staticClass: "projectSubTittle",
	    class: _vm.projectName
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.subTitle)))]), _c('h2', {
	    staticClass: "projectTitle"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.page.title)))])])
	},staticRenderFns: []}

/***/ },
/* 108 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [(_vm.description !== null && _vm.latests !== null) ? _c('div', [(_vm.description.content == null) ? _c('spinner') : _vm._e(), (_vm.description.content != null) ? _c('div', [_c('div', {
	    staticClass: "description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.renderText(_vm.description.content.acf.content, _vm.description.content.acf.contentEn))
	    }
	  }), _c('div', {
	    staticClass: "projectLinks"
	  }, _vm._l((_vm.pages), function(page, index) {
	    return _c('div', {
	      staticClass: "projectLink",
	      class: page.slug
	    }, [_c('router-link', {
	      attrs: {
	        "to": _vm.toAboutPage(page.slug)
	      }
	    }, [_c('p', {
	      staticClass: "subTitle"
	    }, [_vm._v(_vm._s(_vm.renderText(page.subTitle.ja, page.subTitle.en)))]), _c('h2', {
	      staticClass: "projectTitle"
	    }, [_vm._v(_vm._s(_vm.renderText(page.title.ja, page.title.en)))])])])
	  })), _c('h3', {
	    staticClass: "contentTitle"
	  }, [_vm._v(_vm._s(_vm.renderText('活動報告', 'ACTIVITY')))]), _vm._l((_vm.latests), function(posts) {
	    return _c('div', [_vm._l((posts.content), function(post) {
	      return _c('postLink', {
	        staticClass: "postLink",
	        attrs: {
	          "post": post,
	          "projectName": _vm.getProjectSlug(post)
	        }
	      })
	    }), (posts.content == null) ? _c('spinner') : _vm._e()], true)
	  }), _c('p', {
	    staticClass: "readMore"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.toCategory
	    }
	  }, [_vm._v(_vm._s(_vm.renderText('活動報告一覧へ', 'VIEW MORE')))])])], true) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('p', {
	    staticClass: "breadcrumb"
	  }, _vm._l((_vm.objects), function(obj, index) {
	    return _c('span', [(obj.to != null) ? _c('router-link', {
	      attrs: {
	        "to": {
	          name: 'top'
	        }
	      }
	    }, [_vm._v(_vm._s(obj.label))]) : _vm._e(), (obj.to == null) ? _c('span', [_vm._v(_vm._s(obj.label))]) : _vm._e(), (index < _vm.objects.length - 1) ? _c('span', [_vm._v(">")]) : _vm._e()])
	  }))
	},staticRenderFns: []}

/***/ },
/* 110 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('nav', {
	    staticClass: "primaryNav"
	  }, [_c('ul', {
	    staticClass: "pages"
	  }, _vm._l((_vm.primaryNav), function(link) {
	    return _c('li', {
	      class: [{
	        active: _vm.isActive(link)
	      }, _vm.toClass(link.label.en)]
	    }, [_c('router-link', {
	      attrs: {
	        "to": _vm.to(link)
	      }
	    }, [_vm._v(_vm._s(_vm.renderText(link.label)))])])
	  })), _c('ul', {
	    staticClass: "langages"
	  }, [_c('li', {
	    staticClass: "ja",
	    class: {
	      active: !_vm.isEnglish
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.toJa
	    }
	  }, [_vm._v("JA")])]), _c('li', {
	    staticClass: "en",
	    class: {
	      active: _vm.isEnglish
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.toEn
	    }
	  }, [_vm._v("EN")])])])])
	},staticRenderFns: []}

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.pageName.replace('en_', '') == 'post') ? _c('header', [(_vm.projectName != 'all') ? _c('pageTemplateProjectHeader') : _vm._e(), _c('p', {
	    staticClass: "pageTitle",
	    class: _vm.projectName
	  }, [_vm._v(_vm._s(_vm.renderText('活動報告', 'ACTIVITY')))])]) : _vm._e(), _c('div', [(_vm.pageName.replace('en_', '') == 'post') ? _c('p', {
	    staticClass: "meta"
	  }, [_c('span', {
	    staticClass: "category",
	    class: _vm.category(_vm.post).slug
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.category(_vm.post).label.ja, _vm.category(_vm.post).label.en)))]), _c('span', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn)))])]) : _vm._e(), (!_vm.isEnglish && _vm.styledTitleJa) ? _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.styledTitleJa)
	    }
	  }) : (_vm.isEnglish && _vm.styledTitleEn) ? _c('h2', {
	    staticClass: "title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.styledTitleEn)
	    }
	  }) : _c('h2', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))]), _c('htmlRenderer', {
	    attrs: {
	      "content": _vm.renderText(_vm.post.acf.textJa, _vm.post.acf.textEn)
	    }
	  })]), _c('footer', {
	    staticClass: "singleFooter"
	  }, [_c('p', {
	    staticClass: "back",
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v("← " + _vm._s(_vm.renderText('戻る', 'BACK')))])])])
	},staticRenderFns: []}

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('section', {
	    staticClass: "latests"
	  }, [_c('div', {
	    staticClass: "latestHeading"
	  }, [_c('h4', {
	    staticClass: "latestTitle"
	  }, [_vm._v(_vm._s(_vm.renderText(_vm.container.label.ja, _vm.container.label.en)))])]), _vm._l((_vm.container.content), function(post) {
	    return (_vm.container.content != null) ? _c('postLink', {
	      attrs: {
	        "post": post,
	        "projectName": _vm.projectName,
	        "isNew": true
	      }
	    }) : _vm._e()
	  }), _c('router-link', {
	    staticClass: "toPosts readmore",
	    attrs: {
	      "to": _vm.toPosts(_vm.container.slug)
	    }
	  }, [(_vm.projectNo < 4) ? _c('span', [_vm._v("0" + _vm._s(_vm.projectNo))]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.renderText(_vm.container.label.ja + ' 一覧へ', 'READ MORE')))])]), (_vm.container.content == null) ? _c('spinner') : _vm._e()], true)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.73264fd8fe63aceb20b2.js